<template>
  <div class="p-item-empty-panel">
    <template>
      <IconBase
        v-if="type === 'favorite'"
        :width="favoriteIconSize.width"
        :height="favoriteIconSize.height"
        :view-box="`0 0 ${favoriteIconSize.width} ${favoriteIconSize.height}`"
        icon-color="#c4c4c4"
        class="p-item-empty-panel__icon"
      >
        <IconHeartOutline :icon-size="favoriteIconSize.width" />
      </IconBase>
      <IconBase
        v-if="type === 'history'"
        :width="historyIconSize.width"
        :height="historyIconSize.height"
        :view-box="`0 0 ${historyIconSize.width} ${historyIconSize.height}`"
        icon-color="#c4c4c4"
        class="p-item-empty-panel__icon"
      >
        <IconHistory :icon-size="historyIconSize.width" />
      </IconBase>
    </template>
    <p class="p-item-empty-panel__heading">{{ text }}</p>
    <div class="p-form-button-group__vertical p-item-empty-panel__button">
      <ButtonMain :tag="'a'" href="/product-list/">商品を探す</ButtonMain>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHeartOutline from "@/common/components/icons/IconHeartOutline.vue";
import IconHistory from "@/common/components/icons/IconHistory.vue";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    text: { type: String, required: true, default: "" },
    type: { type: String, required: false, default: "" }
  },
  components: {
    ButtonMain,
    IconBase,
    IconHeartOutline,
    IconHistory
  }
})
export default class ItemEmptyPanel extends Vue {
  text!: string;
  type!: string;

  isSp = globals.isSpScreenWidth;

  get favoriteIconSize() {
    if (this.isSp) {
      return {
        width: 56,
        height: 48
      };
    } else {
      return {
        width: 80,
        height: 70
      };
    }
  }
  get historyIconSize() {
    if (this.isSp) {
      return {
        width: 53,
        height: 47
      };
    } else {
      return {
        width: 78,
        height: 69
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.p-item-empty-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: rem(48) 0 rem(56) 0;
  border-top: px(1) solid $common-gray-border;

  @include large-sp {
    padding: rem(52) 0 rem(42) 0;
  }

  &__icon {
    margin-bottom: rem(16);
  }

  &__heading {
    font-weight: bold;
    text-align: center;

    @include large-sp {
      @include text__body--s;
    }
  }

  &__button {
    margin-top: rem(40);

    @include large-sp {
      margin-top: rem(32);
    }
  }
}
</style>
